import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const FACE_FLIP_ACTIVITY_FRAGMENT = gql `
  fragment FaceFlipActivityFragment on FaceFlipActivity {
    rounds {
      cardBack {
        ...AssetFragment
      }
      steps {
        answer
        answerImage {
          image {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default FACE_FLIP_ACTIVITY_FRAGMENT;
